import { getByToken } from 'service/base';

const { selector } = require('recoil');

export const selectorUserInfo = selector({
  key: 'selectorUserInfoUnique',
  get: async ({ get }) => {
    const res = await getByToken();
    if (res?.code !== 0 || res?.status_code) return null;
    return res?.data;
  }
});
